import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSiren: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSiren"><Path d="M4.5 17.5V21.5H19.5V17.5H4.5Z" stroke="currentColor"/><Path d="M6.5 17.5V12C6.5 8.96243 8.96243 6.5 12 6.5C15.0376 6.5 17.5 8.96243 17.5 12V17.5" stroke="currentColor"/><Path d="M12 1.5V2.55M21.45 12H22.5M2.55 12H1.5M18.6822 5.31784L19.4246 4.57538M5.31786 5.31782L4.5754 4.57535" stroke="currentColor" strokeLinecap="square"/><Path d="M12 17.5V14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSiren;
